"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[74],{

/***/ 9765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M4": function() { return /* reexport */ components_BackgroundBannerDefault; },
  "MV": function() { return /* reexport */ components_CTA; },
  "XZ": function() { return /* reexport */ components_Checkbox; },
  "j0": function() { return /* reexport */ components_CostumInput; },
  "YE": function() { return /* reexport */ components_FooterFrontend; },
  "VM": function() { return /* reexport */ components_Hero; },
  "kM": function() { return /* reexport */ components_InputCV; },
  "a_": function() { return /* reexport */ components_LoadingScreen; },
  "rh": function() { return /* reexport */ components_OurClient; },
  "_Y": function() { return /* reexport */ components_OurPartner; },
  "N3": function() { return /* reexport */ components_OurServices; },
  "VL": function() { return /* reexport */ components_ResponseError; },
  "IO": function() { return /* reexport */ components_ScrollNav; },
  "DD": function() { return /* reexport */ components_Sidebar; },
  "Fs": function() { return /* reexport */ components_WAFixed; },
  "v9": function() { return /* reexport */ components_WhyChooseUs; }
});

// UNUSED EXPORTS: HeadInject

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
;// CONCATENATED MODULE: ./components/HeadInject/index.js



function HeadInject(param) {
    var icon = param.icon, title = param.title, description = param.description, keyword = param.keyword;
    return /*#__PURE__*/ _jsxs(Head, {
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: title
            }),
            /*#__PURE__*/ _jsx("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ _jsx("meta", {
                name: "keyword",
                content: keyword
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "icon",
                href: icon
            })
        ]
    });
}
/* harmony default export */ var components_HeadInject = ((/* unused pure expression or super */ null && (HeadInject)));

// EXTERNAL MODULE: ./node_modules/sweetalert/dist/sweetalert.min.js
var sweetalert_min = __webpack_require__(6737);
var sweetalert_min_default = /*#__PURE__*/__webpack_require__.n(sweetalert_min);
// EXTERNAL MODULE: ./redux/userSlice.js
var userSlice = __webpack_require__(8459);
;// CONCATENATED MODULE: ./components/ResponseError/index.js


var ResponseError = function(err, dispatch, history) {
    if (err.response) {
        if (err.response.status === 401) {
            dispatch((0,userSlice/* removeUser */.kX)());
            sweetalert_min_default()("Session Expired", "", "warning");
            history.push("/login");
        } else {
            var ref, ref1;
            sweetalert_min_default()((ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message, "", "error");
        }
    } else if (err.request) {
        // The request was made but no response was received
        sweetalert_min_default()("Error Occured. Please Try Again Later!", "", "error");
    // setLoading(false);
    } else {
        // Something happened in setting up the request that triggered an Error
        sweetalert_min_default()("Error Occured. Please Try Again Later!", "", "error");
    // setLoading(false);
    }
};
/* harmony default export */ var components_ResponseError = (ResponseError);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/BackgroundBannerDefault/index.js
/* eslint-disable @next/next/no-img-element */ 



// import COM from "../../public/assets/com.jpg";
// import Link from 'next/link';
function BackgroundBannerDefault(param) {
    var data = param.data, language = param.language, _isLandingPage = param.isLandingPage, isLandingPage = _isLandingPage === void 0 ? false : _isLandingPage;
    (0,react.useEffect)(function() {
        var handleContentLoaded = function() {
            var stage = document.getElementById("stage");
            var fadeComplete = function fadeComplete() {
                stage.appendChild(arr[0]);
            };
            var arr = stage.getElementsByTagName("a");
            for(var i = 0; i < arr.length; i++){
                arr[i].addEventListener("animationend", fadeComplete, false);
            }
        };
        handleContentLoaded();
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "stage",
        className: "stage",
        children: data === null || data === void 0 ? void 0 : data.map(function(item, index) {
            return item.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: item.url,
                locale: language === "ID" ? "id" : "en",
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            style: {
                                filter: "brightness(0.65)"
                            },
                            alt: language === "EN" ? item === null || item === void 0 ? void 0 : item.en_alt_img : item === null || item === void 0 ? void 0 : item.id_alt_img,
                            src: item["".concat(language.toLowerCase(), "_img")],
                            layout: "fill"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-text",
                            children: isLandingPage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                dangerouslySetInnerHTML: {
                                    __html: item["".concat(language.toLowerCase(), "_detail")]
                                }
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                dangerouslySetInnerHTML: {
                                    __html: item["".concat(language.toLowerCase(), "_detail")]
                                }
                            })
                        })
                    ]
                })
            }, index) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        style: {
                            filter: "brightness(0.65)"
                        },
                        alt: language === "EN" ? item === null || item === void 0 ? void 0 : item.en_alt_img : item === null || item === void 0 ? void 0 : item.id_alt_img,
                        src: item["".concat(language.toLowerCase(), "_img")],
                        layout: "fill"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-text",
                        children: isLandingPage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            dangerouslySetInnerHTML: {
                                __html: item["".concat(language.toLowerCase(), "_detail")]
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            dangerouslySetInnerHTML: {
                                __html: item["".concat(language.toLowerCase(), "_detail")]
                            }
                        })
                    })
                ]
            }, index);
        })
    });
}
/* harmony default export */ var components_BackgroundBannerDefault = (BackgroundBannerDefault);

;// CONCATENATED MODULE: ./public/assets/icons/globe.png
/* harmony default export */ var globe = ({"src":"/_next/static/media/globe.3e50a5a5.png","height":650,"width":650,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAQAAABuBnYAAAAAbUlEQVR42g3LLQ6CABgA0C8TOAMcRItOnBODv8yNgkGGP0QLF7A4k8d9k/q2F0Jq6eOnkESE3KD1MHjq5eFooXNQaa3tw91UY2OnNncbwUSjtFWb6cJJoVM5uyqNJTO46PVaL1kIqdLb10oS8QfgqlHKfGQdCwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/icons/home.png
/* harmony default export */ var home = ({"src":"/_next/static/media/home.4425d0cc.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAQAAABuBnYAAAAAZUlEQVR42h3KOwqEABAE0YYNPIDX2MTUQAM/saGKiKCBieeuPoaN82AomJHED3mMrzLIm2/u7HTGJzOymH1aos6t9D/KVC16D3m+YvNAL3cxeY2JtGh4qGij8kMjChYf3uNgoXgBgctF5NNehcsAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/icons/btn-mobile-menu.png
/* harmony default export */ var btn_mobile_menu = ({"src":"/_next/static/media/btn-mobile-menu.47e25348.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAQAAABuBnYAAAAAO0lEQVR42mP4J/JP4p84BAJZIgz/zv67/+/Ov7tAeAfIOsuAAf41/5vwr/dfHxD2AlnNmALoANNQdGsB/9xHVSotFBUAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/icons/search-blue.png
/* harmony default export */ var search_blue = ({"src":"/_next/static/media/search-blue.8a7d2b08.png","height":20,"width":20,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAclBMVEUDv+gDv+cDvugDvucDvucDv+gDv+gDv+gDv+gDv+gDv+gDv+gDv+gDv+gDvugDv+gDv+gDvugDv+gDvugDv+cDvugDv+cDvucDv+gDvucDv+gDvugDv+gDv+cDvugDvugDv+gDvugDv+gDv+gDv+gDvuhnnTcJAAAAJHRSTlMAAAAAAw8zNTlKS21ub29weXx9jZCcoq60vcDQ0tPU4uTz9fd6K2vTAAAAQklEQVR42gWAhRGAMAwAnxQvWtwt3X9FDspPr0xCrLp08Ak8jYFlFjQlwu3CPWKCsxNyv7abWjDxdPSV1oQGAineH4pzA7A7czSjAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 12 modules
var es = __webpack_require__(1894);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var future_image_default = /*#__PURE__*/__webpack_require__.n(future_image);
;// CONCATENATED MODULE: ./components/Sidebar/index.js
/* eslint-disable no-prototype-builtins */ /* eslint-disable no-unused-vars */ /* eslint-disable @next/next/no-img-element */ /* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable react/prop-types */ 








function Sidebar(param) {
    var openNav = param.openNav, closeNav = param.closeNav, topFunction = param.topFunction, _data = param.data, data = _data === void 0 ? {} : _data, changeLanguage = param.changeLanguage, language = param.language;
    var ref = (0,react.useState)(""), isHovering = ref[0], setIsHovering = ref[1];
    var idFreeConsultation = 20;
    var idCourier = 2;
    var idInternational = 7;
    var idEmail = 22;
    var handleClickFreeConsul = function(url) {
        window.open(url, "_blank", "noopener,noreferrer");
    };
    var handleMouseEnter = function(id) {
        setIsHovering(id);
    };
    var handleMouseLeave = function() {
        setIsHovering("");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "right display-mobile",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "top-nav-menu",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((future_image_default()), {
                                            alt: "ckl logo",
                                            // className="image-icon"
                                            src: "".concat("https://cklcargo.com/", "/assets/icons/globe.png"),
                                            width: 30,
                                            height: 30
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-language",
                                            children: language
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "sub-nav-content",
                                    children: [
                                        language === "ID" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            onClick: changeLanguage,
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "EN"
                                            })
                                        }),
                                        language === "EN" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            onClick: changeLanguage,
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "ID"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "home",
                        style: {
                            cursor: "pointer"
                        },
                        onClick: topFunction,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((future_image_default()), {
                            alt: "home",
                            // className="image-icon"
                            src: "".concat("https://cklcargo.com/", "/assets/icons/home.png"),
                            width: 30,
                            height: 30
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        onClick: openNav,
                        className: "btn-nav-mobile",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((future_image_default()), {
                            alt: "icon",
                            src: btn_mobile_menu,
                            width: 30,
                            height: 30
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "clr"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "mySidenav",
                className: "sidenav",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-top-nav-push",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                locale: language === "ID" ? "id" : "en",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((future_image_default()), {
                                        src: data === null || data === void 0 ? void 0 : data.sidebar_logo,
                                        alt: data === null || data === void 0 ? void 0 : data.alt_sidebar_logo,
                                        // layout="fill"
                                        width: 125,
                                        height: 62
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "closebtn",
                                onClick: closeNav,
                                children: "\xd7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-bottom-nav-push",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "nav-menu-push",
                                children: data.HeaderMenus !== undefined && (data === null || data === void 0 ? void 0 : data.HeaderMenus.map(function(item, index) {
                                    return item.id === idFreeConsultation && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "link-sub-nav",
                                                    children: language === "EN" ? item.en_menu_name : item.id_menu_name
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: "sub-nav-content",
                                                children: item.child.map(function(child, childIndex) {
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: (child === null || child === void 0 ? void 0 : child.id) === idEmail ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: language === "ID" ? "/" + (child === null || child === void 0 ? void 0 : child.id_url) : "/" + (child === null || child === void 0 ? void 0 : child.en_url),
                                                                locale: language === "ID" ? "id" : "en",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    style: {
                                                                        color: isHovering === child.id ? "#02bee8" : ""
                                                                    },
                                                                    onMouseEnter: function() {
                                                                        return child.hasOwnProperty("id_url") || child.hasOwnProperty("en_url") ? handleMouseEnter(child.id) : null;
                                                                    },
                                                                    onMouseLeave: function() {
                                                                        return child.hasOwnProperty("id_url") || child.hasOwnProperty("en_url") ? handleMouseLeave(child.id) : null;
                                                                    },
                                                                    children: language === "ID" ? child.id_menu_name : child.en_menu_name
                                                                })
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "link-sub-nav",
                                                                style: {
                                                                    // cursor: 'pointer',
                                                                    color: isHovering === child.id ? "#02bee8" : ""
                                                                },
                                                                onClick: function() {
                                                                    return handleClickFreeConsul(language === "EN" ? child.en_url : child.id_url);
                                                                },
                                                                onMouseEnter: function() {
                                                                    return handleMouseEnter(child.id);
                                                                },
                                                                onMouseLeave: function() {
                                                                    return handleMouseLeave(child.id);
                                                                },
                                                                children: language === "ID" ? child.id_menu_name : child.en_menu_name
                                                            })
                                                        }, childIndex)
                                                    });
                                                })
                                            })
                                        ]
                                    }, index);
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "input-group",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: "form-control",
                                            placeholder: "Search & Find",
                                            "aria-label": "Search",
                                            "aria-describedby": "search-1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "input-group-text",
                                            id: "search-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((future_image_default()), {
                                                src: search_blue,
                                                alt: "search icon",
                                                className: "image-icon",
                                                // layout="fill"
                                                // loading="eager"
                                                width: 30,
                                                height: 30
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "top-nav-menu",
                                children: data.HeaderMenus !== undefined && (data === null || data === void 0 ? void 0 : data.HeaderMenus.map(function(item, index) {
                                    return item.id === idFreeConsultation && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "link-sub-nav",
                                                    children: language === "EN" ? item.en_menu_name : item.id_menu_name
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: "sub-nav-content",
                                                children: item.child.map(function(child, childIndex) {
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: (child === null || child === void 0 ? void 0 : child.id) === idEmail ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            style: {
                                                                cursor: "pointer"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: language === "ID" ? "/" + (child === null || child === void 0 ? void 0 : child.id_url) : "/" + (child === null || child === void 0 ? void 0 : child.en_url),
                                                                locale: language === "ID" ? "id" : "en",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    style: {
                                                                        color: isHovering === child.id ? "#02bee8" : ""
                                                                    },
                                                                    onMouseEnter: function() {
                                                                        return child.hasOwnProperty("id_url") || child.hasOwnProperty("en_url") ? handleMouseEnter(child.id) : null;
                                                                    },
                                                                    onMouseLeave: function() {
                                                                        return child.hasOwnProperty("id_url") || child.hasOwnProperty("en_url") ? handleMouseLeave(child.id) : null;
                                                                    },
                                                                    children: language === "ID" ? child.id_menu_name : child.en_menu_name
                                                                })
                                                            })
                                                        }, childIndex) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            style: {
                                                                cursor: "pointer"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "link-sub-nav",
                                                                style: {
                                                                    // cursor: 'pointer',
                                                                    color: isHovering === child.id ? "#02bee8" : ""
                                                                },
                                                                onClick: function() {
                                                                    return handleClickFreeConsul(language === "EN" ? child.en_url : child.id_url);
                                                                },
                                                                onMouseEnter: function() {
                                                                    return handleMouseEnter(child.id);
                                                                },
                                                                onMouseLeave: function() {
                                                                    return handleMouseLeave(child.id);
                                                                },
                                                                children: language === "ID" ? child.id_menu_name : child.en_menu_name
                                                            })
                                                        }, childIndex)
                                                    });
                                                })
                                            })
                                        ]
                                    }, index);
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "input-group",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: "form-control",
                                            placeholder: "Search & Find",
                                            "aria-label": "Search",
                                            "aria-describedby": "search-1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "input-group-text",
                                            id: "search-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((future_image_default()), {
                                                src: search_blue,
                                                alt: "search icon",
                                                className: "image-icon",
                                                // layout="fill"
                                                // loading="eager"
                                                width: 30,
                                                height: 30
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "nav-menu-push",
                                children: (data === null || data === void 0 ? void 0 : data.HeaderMenus) !== undefined && (data === null || data === void 0 ? void 0 : data.HeaderMenus.map(function(item, index) {
                                    return item.id !== idFreeConsultation && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: item.hasOwnProperty("child") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "link-sub-nav",
                                                        children: language === "ID" ? item.id_menu_name : item.en_menu_name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                        className: "sub-nav-content",
                                                        children: item.child.map(function(child, childIndex) {
                                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                                                                children: [
                                                                    child.hasOwnProperty("id_url") || child.hasOwnProperty("en_url") ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: language === "ID" ? "/" + (child === null || child === void 0 ? void 0 : child.id_url) : "/" + (child === null || child === void 0 ? void 0 : child.en_url),
                                                                        locale: language === "ID" ? "id" : "en",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            style: {
                                                                                color: isHovering === child.id ? "#02bee8" : ""
                                                                            },
                                                                            onMouseEnter: function() {
                                                                                return child.hasOwnProperty("id_url") || child.hasOwnProperty("en_url") ? handleMouseEnter(child.id) : null;
                                                                            },
                                                                            onMouseLeave: function() {
                                                                                return child.hasOwnProperty("id_url") || child.hasOwnProperty("en_url") ? handleMouseLeave(child.id) : null;
                                                                            },
                                                                            children: language === "ID" ? child.id_menu_name : child.en_menu_name
                                                                        })
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: language === "ID" ? child.id_menu_name : child.en_menu_name
                                                                    }),
                                                                    child.hasOwnProperty("child") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                            className: "subs-nav",
                                                                            children: child.child.map(function(childofchild) {
                                                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                            href: (child === null || child === void 0 ? void 0 : child.id) === idCourier ? "/courier-services/".concat(language === "EN" ? childofchild === null || childofchild === void 0 ? void 0 : childofchild.en_url : childofchild === null || childofchild === void 0 ? void 0 : childofchild.id_url) : child.id === idInternational ? "/international-delivery/".concat(language === "EN" ? childofchild === null || childofchild === void 0 ? void 0 : childofchild.en_url : childofchild === null || childofchild === void 0 ? void 0 : childofchild.id_url) : "/supply-chain/".concat(language === "EN" ? childofchild === null || childofchild === void 0 ? void 0 : childofchild.en_url : childofchild === null || childofchild === void 0 ? void 0 : childofchild.id_url),
                                                                                            locale: language === "ID" ? "id" : "en",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                                children: language === "ID" ? childofchild.id_menu_name : childofchild.en_menu_name
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                });
                                                                            })
                                                                        })
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                                                ]
                                                            }, childIndex);
                                                        })
                                                    })
                                                ]
                                            }, index)
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/".concat(language === "ID" ? item.id_url : item.en_url),
                                                    locale: language === "ID" ? "id" : "en",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: language === "ID" ? item.id_menu_name : item.en_menu_name
                                                    })
                                                })
                                            })
                                        })
                                    });
                                }))
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var components_Sidebar = (Sidebar);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./public/assets/icons/chevrons-down.svg
/* harmony default export */ var chevrons_down = ({"src":"/_next/static/media/chevrons-down.b26cb66f.svg","height":800,"width":800});
;// CONCATENATED MODULE: ./components/ScrollNav/index.js




function ScrollNav() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "#scroll",
                style: {
                    cursor: "pointer"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    width: 100,
                    height: 80,
                    src: chevrons_down,
                    alt: "arrow-navigation",
                    className: "arrow-navigation"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "scroll"
            })
        ]
    });
}
/* harmony default export */ var components_ScrollNav = (ScrollNav);

;// CONCATENATED MODULE: ./components/Hero/index.js
/* eslint-disable */ /* eslint-disable no-prototype-builtins */ /* eslint-disable @next/next/no-img-element */ 





function Hero(param) {
    var language = param.language, _dataHeader = param.dataHeader, dataHeader = _dataHeader === void 0 ? {} : _dataHeader, breadcrump = param.breadcrump;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var router = (0,next_router.useRouter)();
    // karena email (as contact-us) di dalem free consultan
    var idFreeConsultan = 20;
    // ambil url terakhir
    var pathname = router.asPath.split("/").pop();
    // breadcrump yang nampil (parent ke 3)
    var ref10 = (0,react.useState)(""), breadcumbEn = ref10[0], setBreadcumbEn = ref10[1];
    var ref11 = (0,react.useState)(""), breadcumbId = ref11[0], setBreadcumbId = ref11[1];
    // url untuk validasi (parent ke 3)
    var ref12 = (0,react.useState)(""), breadcumbEnUrl = ref12[0], setBreadcumbEnUrl = ref12[1];
    var ref13 = (0,react.useState)(""), breadcumbIdUrl = ref13[0], setBreadcumbIdUrl = ref13[1];
    // breadcrump parent ke 2
    var ref14 = (0,react.useState)(""), breadcumbParentEn = ref14[0], setBreadcumbParentEn = ref14[1];
    var ref15 = (0,react.useState)(""), breadcumbParentId = ref15[0], setBreadcumbParentId = ref15[1];
    (0,react.useEffect)(function() {
        var // keterangan
        // parent 1 = home
        // ini buat ambil parent ke 2 dan 3
        ref;
        breadcrump === null || breadcrump === void 0 ? void 0 : (ref = breadcrump.HeaderMenus) === null || ref === void 0 ? void 0 : ref.forEach(function(item) {
            if ((item === null || item === void 0 ? void 0 : item.hasOwnProperty("child")) && (item === null || item === void 0 ? void 0 : item.id) !== idFreeConsultan) {
                var ref;
                item === null || item === void 0 ? void 0 : (ref = item.child) === null || ref === void 0 ? void 0 : ref.forEach(function(secondItem) {
                    // validate if parent 2 have url (page)
                    if (((secondItem === null || secondItem === void 0 ? void 0 : secondItem.hasOwnProperty("id_url")) || (secondItem === null || secondItem === void 0 ? void 0 : secondItem.hasOwnProperty("en_url"))) && (pathname === (secondItem === null || secondItem === void 0 ? void 0 : secondItem.id_url) || pathname === (secondItem === null || secondItem === void 0 ? void 0 : secondItem.en_url))) {
                        setBreadcumbParentEn(item.en_menu_name);
                        setBreadcumbParentId(item.id_menu_name);
                    // if have parent 3
                    } else {
                        var ref;
                        secondItem === null || secondItem === void 0 ? void 0 : (ref = secondItem.child) === null || ref === void 0 ? void 0 : ref.forEach(function(thirdItem) {
                            if (thirdItem.en_url === pathname && language === "EN") {
                                setBreadcumbEnUrl(secondItem.en_url);
                                setBreadcumbIdUrl(secondItem.id_url);
                                setBreadcumbEn(secondItem.en_menu_name);
                                setBreadcumbId(secondItem.id_menu_name);
                                setBreadcumbParentEn(item.en_menu_name);
                                setBreadcumbParentId(item.id_menu_name);
                            }
                            if (thirdItem.id_url === pathname && language === "ID") {
                                setBreadcumbEnUrl(secondItem.en_url);
                                setBreadcumbIdUrl(secondItem.id_url);
                                setBreadcumbEn(secondItem.en_menu_name);
                                setBreadcumbId(secondItem.id_menu_name);
                                setBreadcumbParentEn(item.en_menu_name);
                                setBreadcumbParentId(item.id_menu_name);
                            }
                        });
                    }
                });
            }
        });
    }, [
        dataHeader
    ]);
    var handleClick = function(url) {
        if (url !== "#") window.open(url, // "https://wa.me/0831?text=oke",
        "_blank", "noopener,noreferrer");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "top-page-courier-service top-page-cs-air-freight",
        style: {
            backgroundImage: "url(" + (dataHeader === null || dataHeader === void 0 ? void 0 : dataHeader.banner_img) + ")"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "page-bg-overlay"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-in-area",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                className: "breadcrumb",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/",
                                            locale: language === "ID" ? "id" : "en",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: "Home"
                                            })
                                        })
                                    }),
                                    language === "EN" && breadcumbParentEn ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: breadcumbParentEn
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    language === "ID" && breadcumbParentId ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: breadcumbParentId
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    language === "EN" && breadcumbEn ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: breadcumbEnUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/" + breadcumbEnUrl,
                                            locale: language === "ID" ? "id" : "en",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: breadcumbEn
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: breadcumbEn
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    language === "ID" && breadcumbId ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: breadcumbIdUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/" + breadcumbIdUrl,
                                            locale: language === "ID" ? "id" : "en",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: breadcumbId
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: breadcumbId
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "active",
                                        children: language === "EN" ? dataHeader.en_title : dataHeader.id_title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "title",
                                dangerouslySetInnerHTML: {
                                    __html: language === "EN" ? dataHeader.en_title : dataHeader.id_title
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "subtitle",
                                dangerouslySetInnerHTML: {
                                    __html: language === "EN" ? dataHeader.en_desc : dataHeader.id_desc
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex gap-3",
                                children: [
                                    (dataHeader === null || dataHeader === void 0 ? void 0 : dataHeader.headerCTA) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-btn-talk",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            className: "btn-talk",
                                            style: {
                                                backgroundColor: dataHeader === null || dataHeader === void 0 ? void 0 : (ref = dataHeader.headerCTA) === null || ref === void 0 ? void 0 : ref.bg_color
                                            },
                                            onClick: function() {
                                                var ref;
                                                return handleClick(dataHeader === null || dataHeader === void 0 ? void 0 : (ref = dataHeader.headerCTA) === null || ref === void 0 ? void 0 : ref.url);
                                            },
                                            type: "button",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((future_image_default()), {
                                                    src: dataHeader === null || dataHeader === void 0 ? void 0 : (ref1 = dataHeader.headerCTA) === null || ref1 === void 0 ? void 0 : ref1.icon,
                                                    alt: dataHeader === null || dataHeader === void 0 ? void 0 : (ref2 = dataHeader.headerCTA) === null || ref2 === void 0 ? void 0 : ref2.alt_icon,
                                                    width: 20,
                                                    height: 20
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: language === "EN" ? dataHeader === null || dataHeader === void 0 ? void 0 : (ref3 = dataHeader.headerCTA) === null || ref3 === void 0 ? void 0 : ref3.en_name : dataHeader === null || dataHeader === void 0 ? void 0 : (ref4 = dataHeader.headerCTA) === null || ref4 === void 0 ? void 0 : ref4.id_name
                                                    }
                                                })
                                            ]
                                        })
                                    }),
                                    (dataHeader === null || dataHeader === void 0 ? void 0 : dataHeader.additional_cta_btn_id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-btn-talk",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            className: "btn-talk",
                                            style: {
                                                backgroundColor: dataHeader === null || dataHeader === void 0 ? void 0 : (ref5 = dataHeader.additionalCTA) === null || ref5 === void 0 ? void 0 : ref5.bg_color
                                            },
                                            onClick: function() {
                                                var ref;
                                                return handleClick(dataHeader === null || dataHeader === void 0 ? void 0 : (ref = dataHeader.additionalCTA) === null || ref === void 0 ? void 0 : ref.url);
                                            },
                                            type: "button",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((future_image_default()), {
                                                    src: dataHeader === null || dataHeader === void 0 ? void 0 : (ref6 = dataHeader.additionalCTA) === null || ref6 === void 0 ? void 0 : ref6.icon,
                                                    alt: dataHeader === null || dataHeader === void 0 ? void 0 : (ref7 = dataHeader.additionalCTA) === null || ref7 === void 0 ? void 0 : ref7.alt_icon,
                                                    width: 20,
                                                    height: 20
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: language === "EN" ? dataHeader === null || dataHeader === void 0 ? void 0 : (ref8 = dataHeader.additionalCTA) === null || ref8 === void 0 ? void 0 : ref8.en_name : dataHeader === null || dataHeader === void 0 ? void 0 : (ref9 = dataHeader.additionalCTA) === null || ref9 === void 0 ? void 0 : ref9.id_name
                                                    }
                                                })
                                            ]
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ScrollNav, {})
                ]
            })
        ]
    });
}
/* harmony default export */ var components_Hero = (Hero);

// EXTERNAL MODULE: ./node_modules/@coreui/react/dist/index.es.js
var index_es = __webpack_require__(4475);
;// CONCATENATED MODULE: ./components/WhyChooseUs/index.js
/* eslint-disable @next/next/no-img-element */ 



function WhyChooseUs(param) {
    var en_name = param.en_name, id_name = param.id_name, _dataBtn = param.dataBtn, dataBtn = _dataBtn === void 0 ? [] : _dataBtn, _dataContent = param.dataContent, dataContent = _dataContent === void 0 ? [] : _dataContent, selected = param.selected, setSelected = param.setSelected, language = param.language;
    var handleResize = function handleResize() {
        setWidth(window.innerWidth);
    };
    var styled = {
        "--cui-accordion-active-bg": "#dcf2ff",
        "--cui-accordion-active-color": "1px solid"
    };
    var ref = (0,react.useState)(undefined), width = ref[0], setWidth = ref[1];
    (0,react.useEffect)(function() {
        if (true) {
            setWidth(window.innerWidth);
        }
        window.addEventListener("resize", handleResize);
        handleResize();
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "title",
                            dangerouslySetInnerHTML: {
                                __html: language === "EN" ? en_name : id_name
                            }
                        })
                    })
                }),
                width > 1200 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-tabs-why-choose-us",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex align-items-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "nav flex-column nav-pills me-3",
                                        id: "v-pills-tab",
                                        role: "tablist",
                                        "aria-orientation": "vertical",
                                        children: dataBtn === null || dataBtn === void 0 ? void 0 : dataBtn.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: "nav-link ".concat(selected === item.id ? "active" : ""),
                                                onClick: function() {
                                                    return setSelected(item.id);
                                                },
                                                dangerouslySetInnerHTML: {
                                                    __html: language === "EN" ? item.en_title : item.id_title
                                                }
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tab-content",
                                        id: "v-pills-tabContent",
                                        children: dataContent === null || dataContent === void 0 ? void 0 : dataContent.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "tab-pane fade ".concat(selected === item.id ? "show active" : ""),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: language === "EN" ? item.en_img : item.id_img,
                                                        alt: language === "EN" ? item.alt_en_img : item.alt_id_img,
                                                        width: 918,
                                                        height: 516
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "title-content-tabs",
                                                        dangerouslySetInnerHTML: {
                                                            __html: language === "EN" ? item.en_title : item.id_title
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-content-tabs",
                                                        dangerouslySetInnerHTML: {
                                                            __html: language === "EN" ? item.en_desc : item.id_desc
                                                        }
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                ]
                            })
                        })
                    })
                }),
                width < 1200 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CAccordion */.uz, {
                    flush: true,
                    style: styled,
                    children: dataContent.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* CAccordionItem */.Ob, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CAccordionHeader */.Lv, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        dangerouslySetInnerHTML: {
                                            __html: language === "EN" ? item.en_title : item.id_title
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CAccordionBody */.qI, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat(selected === item.id ? "show active" : ""),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: language === "EN" ? item.en_img : item.id_img,
                                                alt: language === "EN" ? item.alt_en_img : item.alt_id_img,
                                                width: 896,
                                                height: 504
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                style: {
                                                    marginTop: "30px"
                                                },
                                                className: "title-content-tabs",
                                                dangerouslySetInnerHTML: {
                                                    __html: language === "EN" ? item.en_title : item.id_title
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-content-tabs",
                                                dangerouslySetInnerHTML: {
                                                    __html: language === "EN" ? item.en_desc : item.id_desc
                                                }
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, index);
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var components_WhyChooseUs = (WhyChooseUs);

;// CONCATENATED MODULE: ./components/FooterFrontend/index.js
/* eslint-disable @next/next/no-img-element */ 



function FooterFrontend(param) {
    var footer = param.footer, language = param.language;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "top-footer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/",
                                    locale: language === "ID" ? "id" : "en",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((future_image_default()), {
                                            width: 130,
                                            height: 70,
                                            src: footer === null || footer === void 0 ? void 0 : footer.logo,
                                            className: "logo-ckl",
                                            alt: footer === null || footer === void 0 ? void 0 : footer.alt_logo
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row",
                                    children: footer === null || footer === void 0 ? void 0 : (ref = footer.FooterMenus) === null || ref === void 0 ? void 0 : ref.map(function(list, index) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                            className: "col-md-".concat(index === 0 ? "2" : index === 3 ? "4" : "3"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: language === "EN" ? list.en_menu_name : list.id_menu_name
                                                    }
                                                }),
                                                list === null || list === void 0 ? void 0 : list.child.map(function(item, itemIndex) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: language === "EN" ? item.en_url ? "/" + item.en_url : "#" : item.id_url ? "/" + item.id_url : "#",
                                                            locale: language === "ID" ? "id" : "en",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                dangerouslySetInnerHTML: {
                                                                    __html: language === "EN" ? item.en_menu_name : item.id_menu_name
                                                                }
                                                            })
                                                        })
                                                    }, itemIndex);
                                                })
                                            ]
                                        }, index);
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bottom-footer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    dangerouslySetInnerHTML: {
                                        __html: footer === null || footer === void 0 ? void 0 : footer.copyright
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-medsos",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "d-flex justify-content-md-end align-items-center",
                                        children: [
                                            "Follow Us :",
                                            footer === null || footer === void 0 ? void 0 : (ref1 = footer.FooterSocMeds) === null || ref1 === void 0 ? void 0 : ref1.map(function(list, index) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)((link_default()), {
                                                    href: list.url ? list.url : "#",
                                                    locale: language === "ID" ? "id" : "en",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "m-1",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((future_image_default()), {
                                                                width: 20,
                                                                height: 20,
                                                                src: list === null || list === void 0 ? void 0 : list.icon,
                                                                alt: list === null || list === void 0 ? void 0 : list.name
                                                            })
                                                        })
                                                    })
                                                }, index);
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var components_FooterFrontend = (FooterFrontend);

;// CONCATENATED MODULE: ./components/OurServices/index.js
/* eslint-disable @next/next/no-img-element */ /* eslint-disable react/prop-types */ 


function OurServices(param) {
    var en_service_text = param.en_service_text, id_service_text = param.id_service_text, dataOurServices = param.dataOurServices, language = param.language;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "title",
                            dangerouslySetInnerHTML: {
                                __html: language === "EN" ? en_service_text : id_service_text
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-bottom-nav-tabs",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: dataOurServices === null || dataOurServices === void 0 ? void 0 : dataOurServices.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-sm-6 col-md-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-thumbnail",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "box-img",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((future_image_default()), {
                                                width: 120,
                                                height: 50,
                                                src: language === "EN" ? item.en_img : item.id_img,
                                                alt: language === "EN" ? item.en_alt_img : item.id_alt_img
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "caption",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: language === "EN" ? item.en_name : item.id_name
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: language === "EN" ? item.en_desc : item.id_desc
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, index);
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var components_OurServices = (OurServices);

;// CONCATENATED MODULE: ./components/CTA/index.js
/* eslint-disable */ 


function CTA(param) {
    var CTAButton = param.CTAButton, id_desc = param.id_desc, en_desc = param.en_desc, language = param.language;
    var handleClick = function(url) {
        if (url !== "#") window.open(url, "_blank", "noopener,noreferrer");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "col-talk",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-9",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                dangerouslySetInnerHTML: {
                                    __html: language === "EN" ? en_desc : id_desc
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-btn-talk",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    className: "btn-talk",
                                    style: {
                                        backgroundColor: CTAButton === null || CTAButton === void 0 ? void 0 : CTAButton.bg_color
                                    },
                                    onClick: function() {
                                        return handleClick(CTAButton === null || CTAButton === void 0 ? void 0 : CTAButton.url);
                                    },
                                    type: "button",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((future_image_default()), {
                                            src: CTAButton === null || CTAButton === void 0 ? void 0 : CTAButton.icon,
                                            alt: CTAButton === null || CTAButton === void 0 ? void 0 : CTAButton.alt_icon,
                                            width: 20,
                                            height: 20
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            dangerouslySetInnerHTML: {
                                                __html: language === "EN" ? CTAButton === null || CTAButton === void 0 ? void 0 : CTAButton.en_name : CTAButton === null || CTAButton === void 0 ? void 0 : CTAButton.id_name
                                            }
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ var components_CTA = (CTA);

;// CONCATENATED MODULE: ./components/OurPartner/index.js
/* eslint-disable */ 


function OurPartner(param) {
    var partner = param.partner, id_title = param.id_title, en_title = param.en_title, language = param.language;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("center", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "title",
                                dangerouslySetInnerHTML: {
                                    __html: language === "EN" ? en_title : id_title
                                }
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-our-client",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row justify-content-md-center",
                        children: partner === null || partner === void 0 ? void 0 : partner.map(function(item, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                className: "col-sm-6 col-md-2 mb-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((future_image_default()), {
                                    width: 120,
                                    height: 70,
                                    src: item.icon,
                                    alt: item === null || item === void 0 ? void 0 : item.alt_icon
                                })
                            }, index);
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var components_OurPartner = (OurPartner);

;// CONCATENATED MODULE: ./components/OurClient/index.js
/* eslint-disable */ 


function OurClient(param) {
    var client = param.client, id_title = param.id_title, en_title = param.en_title, language = param.language;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("center", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "title",
                                dangerouslySetInnerHTML: {
                                    __html: language === "EN" ? en_title : id_title
                                }
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-our-client",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row justify-content-md-center",
                        children: client === null || client === void 0 ? void 0 : client.map(function(item, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                className: "col-sm-6 col-md-3 mb-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((future_image_default()), {
                                    width: 120,
                                    height: 70,
                                    src: item.icon,
                                    alt: item === null || item === void 0 ? void 0 : item.alt_icon
                                })
                            }, index);
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var components_OurClient = (OurClient);

;// CONCATENATED MODULE: ./components/WAFixed/index.js
/* eslint-disable @next/next/no-img-element */ /* eslint-disable react/prop-types */ 


function WAFixed(param) {
    var data = param.data;
    var handleClick = function() {
        // url;
        if ((data === null || data === void 0 ? void 0 : data.url) !== "#") window.open(data === null || data === void 0 ? void 0 : data.url, "_blank", "noopener,noreferrer");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "position-fixed-whatsapp",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            className: "btn-talk",
            onClick: handleClick,
            type: "button",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                width: 30,
                height: 30,
                src: data === null || data === void 0 ? void 0 : data.icon,
                alt: data === null || data === void 0 ? void 0 : data.alt_icon
            })
        })
    });
}
/* harmony default export */ var components_WAFixed = (WAFixed);

// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
;// CONCATENATED MODULE: ./components/LoadingScreen/index.js
/* eslint-disable @next/next/no-img-element */ 



function LoadingScreen() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "Loading ..."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "d-flex justify-content-center align-items-center vh-100",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((future_image_default()), {
                        alt: "logo",
                        src: "".concat("https://cklcargo.com/", "/assets/icons/logo_loading.gif"),
                        height: 200,
                        width: 200
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var components_LoadingScreen = (LoadingScreen);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 38 modules
var react_select_esm = __webpack_require__(1746);
;// CONCATENATED MODULE: ./utils/styleReactSelect.js


var primary = {
    control: function(base, state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
            border: state.isFocused ? "1px solid #b1b7c1" : "1px solid #b1b7c1",
            outline: state.isFocused ? "none" : "none",
            boxShadow: state.isFocused ? "none" : "none",
            "&:hover": {
                border: "1px solid #b1b7c1",
                boxShadow: "none"
            }
        });
    }
};

// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
;// CONCATENATED MODULE: ./components/CostumInput/index.js
/* eslint-disable */ /* eslint-disable react/prop-types */ 








// TEXT, EMAIL, NUMBER, PASSWORD, DATE, SELECT, TEXTAREA, SEARCH, IMAGE
var CostumInput = function(param) {
    var register = param.register, label = param.label, name = param.name, disabled = param.disabled, // validation
    errors = param.errors, isReqMsg = param.isReqMsg, // length
    minLength = param.minLength, minLengthMsg = param.minLengthMsg, maxLength = param.maxLength, maxLengthMsg = param.maxLengthMsg, // pattern,
    pattern = param.pattern, patternMsg = param.patternMsg, // type (REQUIRED)
    type = param.type, // if for phone, then use this
    phone = param.phone, // if for career frontend, then use this
    careerFrontend = param.careerFrontend, // if type is SELECT, then use this
    Controller = param.controller, dataSelect = param.dataSelect, handleSelect = param.handleSelect, nameParent = param.nameParent, control = param.control, isClearable = param.isClearable, // if type is salary, then use this
    handleChangeSalary = param.handleChangeSalary, // if type is SELECT MULTI, then use this
    isMulti = param.isMulti, valueSelect = param.valueSelect, valueLength = param.valueLength, // if type is SEARCH, then use this
    placeholder = param.placeholder, setSearch = param.setSearch, setCurrentPage = param.setCurrentPage, refetch = param.refetch, // if type is IMAGE, then use this
    showPhoto = param.showPhoto, setShowPhoto = param.setShowPhoto, setPhoto = param.setPhoto, altImg = param.altImg;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)(true), isPassword = ref4[0], setIsPassword = ref4[1];
    var inputRef = (0,react.useRef)(null);
    // for search
    var handleSearch = function(e) {
        setSearch(e.target.value);
        setCurrentPage(1);
    };
    var handleKeyPress = function(e) {
        if (e.key === "Enter") {
            setCurrentPage(1);
            refetch();
        }
    };
    var getBase64 = function(file) {
        return new Promise(function(resolve, reject) {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function() {
                return resolve(reader.result);
            };
            reader.onerror = function(error) {
                return reject(error);
            };
        });
    };
    var handleFile = function(e) {
        var file = e.target.files[0];
        if (file.size > 1048576) {
            sweetalert_min_default()("Ukuran file terlalu besar, maksimal 1MB", "", "error");
        } else if (file.type !== "image/png" && file.type !== "image/jpg" && file.type !== "image/jpeg") {
            sweetalert_min_default()("File format tidak sesuai, format yang diterima harus jpg, jpeg, png", "", "error");
        } else if (file) {
            getBase64(file).then(function(data) {
                setShowPhoto(URL.createObjectURL(file));
                setPhoto(data);
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "costum-input",
        children: [
            careerFrontend ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: label && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CFormLabel */.L8, {
                    style: {
                        color: "white"
                    },
                    children: label
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: label && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CFormLabel */.L8, {
                    children: label
                })
            }),
            isReqMsg ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CFormLabel */.L8, {
                style: {
                    color: "red",
                    marginLeft: "5px"
                },
                children: "*"
            }) : null,
            type === "text" || type === "email" || type === "number" || type === "date" || type === "month" || type === "slug" || type === "title" || type === "grade" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CFormInput */.jO, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        // className="costum-input-input"
                        className: "form-input",
                        placeholder: placeholder,
                        disabled: disabled
                    }, register(name, {
                        required: isReqMsg,
                        minLength: {
                            value: minLength,
                            message: minLengthMsg
                        },
                        min: type !== "grade" ? {} : {
                            value: 0,
                            message: "Min 0"
                        },
                        max: type !== "grade" ? {} : {
                            value: 4,
                            message: "Max 4"
                        },
                        maxLength: {
                            value: maxLength,
                            message: maxLengthMsg
                        },
                        // pattern: {
                        //   value:
                        //     type === "email"
                        //       ? /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        //       : type === "slug"
                        //         ? /^[a-z][a-z\-]*[a-z]$/
                        //         : pattern,
                        //   message: patternMsg,
                        // },
                        pattern: {
                            value: type === "email" ? /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ : type === "slug" ? /^[a-z0-9]+(?:-[a-z0-9]+)*$/ : type === "title" ? /^[a-zA-Z0-9 ]+$/ : pattern,
                            message: patternMsg
                        }
                    })), {
                        type: isPassword && type === "password" ? "password" : type === "date" ? "date" : type === "month" ? "month" : type === "grade" ? "number" : "text",
                        onKeyPress: type === "number" || phone ? function(e) {
                            if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                            }
                        } : type === "grade" ? function(e) {
                            if (!/[0-9,.]/.test(e.key)) {
                                e.preventDefault();
                            }
                        } : null,
                        onKeyDown: type === "date" ? function(e) {
                            return e.preventDefault();
                        } : null
                    })),
                    type === "password" && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CInputGroupText */.wV, {
                        style: {
                            background: "none",
                            borderLeft: "none",
                            cursor: "pointer"
                        },
                        className: "form-input",
                        onClick: function() {
                            return setIsPassword(function(currentValue) {
                                return !currentValue;
                            });
                        },
                        children: isPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiFillEye */.w8I, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiFillEyeInvisible */.p3W, {})
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            type === "salary" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* CInputGroup */.YR, {
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CInputGroupText */.wV, {
                        id: "basic-addon1",
                        children: "Rp"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CFormInput */.jO, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        // className="costum-input-input"
                        className: "form-input",
                        placeholder: placeholder,
                        disabled: disabled
                    }, register(name, {
                        required: isReqMsg
                    })), {
                        onChange: handleChangeSalary,
                        type: "text",
                        onKeyPress: function(e) {
                            if (!/[0-9.]/.test(e.key)) {
                                e.preventDefault();
                            }
                        }
                    }))
                ]
            }),
            type === "color" && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CFormInput */.jO, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register(name, {
                required: isReqMsg
            })), {
                type: "color"
            })),
            type === "location" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "d-flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CFormInput */.jO, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        // className="costum-input-input"
                        className: "form-input",
                        placeholder: "Latitude",
                        disabled: disabled,
                        onKeyPress: type === "number" ? function(e) {
                            if (!/[0-9,.-]/.test(e.key)) {
                                e.preventDefault();
                            }
                        } : null
                    }, register("latitude", {
                        required: isReqMsg
                    })), {
                        type: "number"
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CFormInput */.jO, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        // className="costum-input-input"
                        className: "form-input",
                        placeholder: "Longitude",
                        disabled: disabled
                    }, register("longitude", {
                        required: isReqMsg
                    })), {
                        type: "number"
                    }))
                ]
            }),
            type === "password" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* CInputGroup */.YR, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CFormInput */.jO, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            // className="costum-input-input"
                            className: "form-input",
                            placeholder: placeholder
                        }, register(name, {
                            required: isReqMsg,
                            minLength: {
                                value: minLength,
                                message: minLengthMsg
                            },
                            maxLength: {
                                value: maxLength,
                                message: maxLengthMsg
                            },
                            pattern: {
                                value: type === "email" ? /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ : pattern,
                                message: patternMsg
                            }
                        })), {
                            type: isPassword && type === "password" ? "password" : "text"
                        })),
                        type === "password" && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CInputGroupText */.wV, {
                            style: {
                                background: "none",
                                borderLeft: "none",
                                cursor: "pointer"
                            },
                            className: "form-input",
                            onClick: function() {
                                return setIsPassword(function(currentValue) {
                                    return !currentValue;
                                });
                            },
                            children: isPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiFillEye */.w8I, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiFillEyeInvisible */.p3W, {})
                        })
                    ]
                })
            }),
            type === "search" && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CFormInput */.jO, {
                className: "form-input",
                placeholder: placeholder,
                onKeyPress: handleKeyPress,
                onChange: handleSearch
            }),
            type === "textarea" && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CFormTextarea */.PB, (0,_object_spread/* default */.Z)({
                className: "form-input",
                disabled: disabled,
                rows: 4
            }, register(name, {
                required: isReqMsg,
                minLength: {
                    value: minLength,
                    message: minLengthMsg
                },
                maxLength: {
                    value: maxLength,
                    message: maxLengthMsg
                }
            }))),
            type === "select" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Controller, {
                render: function(param) {
                    var field = param.field;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register(name, {
                        required: isReqMsg
                    }), field), {
                        styles: primary,
                        isDisabled: disabled,
                        options: dataSelect,
                        onChange: handleSelect,
                        isClearable: isClearable,
                        placeholder: placeholder
                    }));
                },
                name: nameParent,
                control: control
            }),
            type === "select-multi" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Controller, {
                render: function(param) {
                    var field = param.field;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register(name, {
                        required: isReqMsg
                    }), field), {
                        styles: primary,
                        options: dataSelect,
                        onChange: handleSelect,
                        isClearable: isClearable,
                        isMulti: isMulti,
                        placeholder: placeholder,
                        value: valueSelect
                    }));
                },
                name: nameParent,
                control: control
            }),
            type === "image" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: showPhoto ? showPhoto : "http://repo.lyrid.id:9500/uploads/-/system/appearance/header_logo/1/favicon.png",
                        width: "300px",
                        onClick: function() {
                            return inputRef.current.click();
                        },
                        style: {
                            cursor: "pointer"
                        },
                        alt: altImg
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        ref: inputRef,
                        type: "file",
                        style: {
                            display: "none"
                        },
                        onChange: handleFile
                    })
                ]
            }),
            type === "select" && errors ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                style: {
                    color: "#e55353",
                    fontSize: "13px",
                    marginTop: "5px"
                },
                children: ((ref = errors[nameParent]) === null || ref === void 0 ? void 0 : ref.value) && ((ref1 = errors[nameParent]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.message)
            }) : type === "location" && errors ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                style: {
                    color: "#e55353",
                    fontSize: "13px",
                    marginTop: "5px"
                },
                children: errors["latitude"] || errors["longitude"] ? "Location Not Valid" : null
            }) : type !== "select" && errors ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                style: {
                    color: "#e55353",
                    fontSize: "13px",
                    marginTop: "5px"
                },
                children: errors[name] && ((ref3 = errors[name]) === null || ref3 === void 0 ? void 0 : ref3.message)
            }) : null
        ]
    });
};
/* harmony default export */ var components_CostumInput = (CostumInput);

;// CONCATENATED MODULE: ./components/Checkbox/index.js
/* eslint-disable */ /* eslint-disable react/prop-types */ 








var Checkbox = function(param) {
    var register = param.register, label = param.label, name = param.name, disabled = param.disabled, onChange = param.onChange, // validation
    errors = param.errors, isReqMsg = param.isReqMsg;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "costum-input",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CFormCheck */.EC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                // className="costum-input-input"
                className: "form-input",
                disabled: disabled
            }, register(name, {
                required: isReqMsg
            })), {
                onChange: onChange,
                type: "checkbox"
            })),
            "\xa0",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CFormLabel */.L8, {
                children: label
            }),
            errors && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                style: {
                    color: "#e55353",
                    fontSize: "13px",
                    marginTop: "5px"
                },
                children: errors[name] && ((ref = errors[name]) === null || ref === void 0 ? void 0 : ref.message)
            })
        ]
    });
};
/* harmony default export */ var components_Checkbox = (Checkbox);

// EXTERNAL MODULE: ./utils/colors.js
var colors = __webpack_require__(3990);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
;// CONCATENATED MODULE: ./components/InputCV/index.js
/* eslint-disable */ /* eslint-disable react/prop-types */ 







function InputCV(param) {
    var _label = param.label, label = _label === void 0 ? "Background Image" : _label, CV = param.CV, setCV = param.setCV, nameFile = param.nameFile, setNameFile = param.setNameFile, inputRef = param.inputRef, // validation
    register = param.register, name = param.name, errors = param.errors, setValue = param.setValue;
    var ref;
    var handleFileBG = function(e) {
        var file = e.target.files[0];
        // 5 MB
        if (file.size > 5242880) {
            sweetalert_min_default()("Ukuran file terlalu besar, maksimal 5MB", "", "error");
        } else if (file.type !== "application/pdf") {
            sweetalert_min_default()("File format tidak sesuai, format yang diterima harus pdf", "", "error");
        } else if (file) {
            setNameFile(file === null || file === void 0 ? void 0 : file.name);
            setCV(file);
            // validate
            setValue(name, file);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CFormLabel */.L8, {
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CFormLabel */.L8, {
                style: {
                    color: "red",
                    marginLeft: "5px"
                },
                children: "*"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-flex justify-content-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    background: "rgb(2, 46, 80)",
                                    fontWeight: "600",
                                    borderRadius: "5px",
                                    color: colors/* default.white */.Z.white,
                                    padding: "8px 22px",
                                    textAlign: "center",
                                    border: "1px solid rgb(2, 46, 80)",
                                    marginBottom: "10px",
                                    width: "45%",
                                    cursor: "pointer"
                                },
                                onClick: function() {
                                    return inputRef.current.click();
                                },
                                children: [
                                    "Upload Resume / CV ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdUpload */.Ap8, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    background: colors/* default.gray1 */.Z.gray1,
                                    fontWeight: "600",
                                    borderRadius: "5px",
                                    padding: "8px 22px",
                                    textAlign: "left",
                                    border: "1px solid ".concat(colors/* default.gray1 */.Z.gray1),
                                    marginBottom: "10px",
                                    width: "45%"
                                },
                                align: "right",
                                children: nameFile ? nameFile : "Tidak Ada File"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "*Format File PDF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "*Max File 5 MB"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CFormInput */.jO, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register(name, {
                        required: "Required"
                    })), {
                        ref: inputRef,
                        type: "file",
                        style: {
                            display: "none"
                        },
                        onChange: handleFileBG
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        style: {
                            color: "#e55353",
                            fontSize: "13px",
                            marginTop: "5px"
                        },
                        children: errors[name] && ((ref = errors[name]) === null || ref === void 0 ? void 0 : ref.message)
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var components_InputCV = (InputCV);

;// CONCATENATED MODULE: ./components/index.js




















/***/ }),

/***/ 3990:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var colors = {
    green: "#016853",
    orange: "#fd6c10",
    yellow: "#fec627",
    pink: "#f095cd",
    black: "#000000",
    white: "#ffffff",
    gray: "#3B4B64",
    // gray2: "#9DA5B1",
    red: "#c13d3d",
    // ckl
    blue1: "#102D4E",
    blue2: "#214F6B",
    blue3: "#49A0E5",
    blue4: "#55BBE3",
    gray1: "#BDBDBD",
    gray2: "#E8E8E8",
    background: "#F0F6F8",
    backgroundTitle: "#DAE9EC",
    borderTable: "#979797"
};
/* harmony default export */ __webpack_exports__["Z"] = (colors);


/***/ }),

/***/ 471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useLoading; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


var useLoading = function(value) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(value), loading = ref[0], setLoading = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        next_router__WEBPACK_IMPORTED_MODULE_0__.Router.events.on("routeChangeStart", function() {
            return setLoading(true);
        });
        next_router__WEBPACK_IMPORTED_MODULE_0__.Router.events.on("routeChangeComplete", function() {
            return setLoading(false);
        });
        next_router__WEBPACK_IMPORTED_MODULE_0__.Router.events.on("routeChangeError", function() {
            return setLoading(false);
        });
        return function() {
            next_router__WEBPACK_IMPORTED_MODULE_0__.Router.events.off("routeChangeStart", function() {
                return setLoading(true);
            });
            next_router__WEBPACK_IMPORTED_MODULE_0__.Router.events.off("routeChangeComplete", function() {
                return setLoading(false);
            });
            next_router__WEBPACK_IMPORTED_MODULE_0__.Router.events.off("routeChangeError", function() {
                return setLoading(false);
            });
        };
    }, [
        next_router__WEBPACK_IMPORTED_MODULE_0__.Router.events
    ]);
    return loading;
};


/***/ })

}]);